import { Typography, Button, Upload } from "antd";
import React, { useState, useEffect } from "react";
import {
  UploadOutlined,
  RollbackOutlined,
  DownloadOutlined,
  InboxOutlined,
} from "@ant-design/icons";

import Pageloader from "../../../components/loader";
import { getBatchDefaultSettingList } from "../../../services/batch.service";
import { getZoneList } from "../../../services/zone.service";
import { BASE_URL } from "../../../config/Baseurl";

import { useNavigate } from "react-router-dom";
import { swalNotification } from "../../../components/alret/notificztion";
import { validationErrors } from "../../../utils/Helpers";
import { Link } from "react-router-dom";
import { UploadProps } from "antd";

const { Title } = Typography;
const { Dragger } = Upload;

const RiderInactiveBulkCsv = () => {
  const navigate = useNavigate();

  const pagename = "Rider Active/Inactive Bulk";
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [postDataBatch, setPostDataBatch] = useState(null);
  const [postDataZone, setPostDataZone] = useState(null);
  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    try {
      setLoading(true);
      // const respzone = await getZoneList();
      // setPostDataZone(respzone.data.data);
      // const respBatch = await getBatchDefaultSettingList();
      // setPostDataBatch(respBatch.data.data);
    } catch (error) {
      // setErrMsg("Something went wrong");
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };
  // Zone Sorts Start
  useEffect(() => {
    if (postDataZone) {
      zoneopction();
    }
  }, [postDataZone]);
  const [postDataZoneOpction, setPostDataZoneOpction] = useState(null);
  const zoneopction = () => {
    let dataToConvert = [];
    postDataZone.map((item, idx) => {
      const shiftZonelist = {
        label: item.zoneName,
        value: item.id,
      };
      dataToConvert.push(shiftZonelist);
    });
    setPostDataZoneOpction(dataToConvert);
  };
  // Zone Sorts End

  const propsNew: UploadProps = {
    name: "activeRiderCsv",
    action: BASE_URL + "api/web/rider/active-status-many",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        // message.success(`${info.file.name} file uploaded successfully`);
        swalNotification(
          "Rider active",
          "Rider active successfully",
          "success"
        );
        navigate("/rider");
      } else if (info.file.status === "error") {
        // message.error(`${info.file.name} file upload failed.`);
        if (info.fileList.length != 0) {
          swalNotification("Some error!", "Error", "error");
        }
      }
    },
  };

  return loading ? (
    <Pageloader />
  ) : (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch-title">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch-content">
          {/* <Upload accept=".csv" className="rockyupload" {...propsNew}>
            <Button disabled={fileList.length === 1} icon={<UploadOutlined />}>
              Select File
            </Button>
          </Upload> */}
          <Button>
            <Link
              to="/files/activeRiderCsv.csv"
              target="_blank"
              download
            >
              <DownloadOutlined /> Download Sample File
            </Link>
          </Button>
          <Button onClick={() => navigate("/rider")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>

      <Dragger {...propsNew}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag bulk rider Active/Inactive csv file to this area to upload
        </p>
      </Dragger>
    </div>
  );
};

export default RiderInactiveBulkCsv;
